import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
export function CostOfNotStarting() {
  const costs = ['Seguir dependiendo de un sueldo que no alcanza', 'Seguir postergando tu emprendimiento', 'Seguir mirando ideas sin actuar', 'Perder tiempo viendo tutoriales incompletos', 'Seguir pensando “algún día voy a empezar”'];
  return <section className="py-10 px-4 bg-slate-900 text-white" data-id="element-42">
      <div className="max-w-4xl mx-auto" data-id="element-43">
        <div className="text-center mb-5" data-id="element-44">
          <h2 className="text-2xl md:text-3xl font-bold" data-id="element-45">
            ⚖️ ¿CUÁNTO CUESTA NO EMPEZAR?
          </h2>
        </div>

        <div className="bg-slate-800 rounded-2xl p-5 md:p-7 border border-slate-700 shadow-2xl max-w-2xl mx-auto" data-id="element-46">
          <ul className="space-y-2 mb-5" data-id="element-47">
            {costs.map((cost, idx) => <li key={idx} className="flex items-start gap-3 text-slate-300 font-medium text-base" data-id="element-48">
                <div className="bg-red-500/20 text-red-400 p-0.5 rounded-full shrink-0 mt-1" data-id="element-49">
                  <CloseIcon fontSize="small" data-id="element-50" />
                </div>
                <span data-id="element-51">{cost}</span>
              </li>)}
          </ul>

          <div className="text-center border-t border-slate-700 pt-4" data-id="element-52">
            <p className="text-base text-slate-400 mb-1" data-id="element-53">
              El mejor momento para empezar fue ayer.
            </p>
            <p className="text-xl font-bold text-brand-400" data-id="element-54">
              El segundo mejor momento es hoy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}